import React, { memo } from 'react';

import BrandLogo from 'components/Shared/Company/BrandLogo/container';

import { getUrl } from 'utils/url';
import CatchError from 'components/CatchError';
import { PrimaryNavStyled } from 'components/NavigationBar/style';
import Tabs from 'components/NavigationBar/Tabs';

type Props = {
    className?: string;
    currentPath: string;
};

const NavigationBar = ({
    className = '',
    currentPath
}: Props) => (
    <CatchError fallbackRender="error">
        <PrimaryNavStyled className={`ui-primary-nav ${className}`}>
            <BrandLogo size="md" type="shortLogo" href={getUrl('dashboard')} />
            <div className="menu">
                <Tabs currentPath={currentPath} />
            </div>
        </PrimaryNavStyled>
    </CatchError>
);

export default memo(NavigationBar);
